import * as React from "react"
import PropTypes from "prop-types"
import { storyblokInit, apiPlugin, RichTextSchema } from "gatsby-source-storyblok"
import { useStaticQuery, graphql } from "gatsby"
import cloneDeep from "clone-deep";
import configuration from '../../gatsby-config'
import Grid from "./grid"
import AdBannerImage from "./adBannerImage"
import Navigation from "./header"
import MenuLink from "./menuLink"
import Footer from "./footer"
import BlogArticle from "./blogArticle"
import BodyText from "./bodyText"
import Images from "./images"
import Location from "./location"
import Carousel from "./carousel"
import PopularInterest from "./popularInterest"
import FeatureSection from "./featureSection"
import SearchTabs from "./searchTabs"
import SearchTabsJp from "./searchTabsJp"
// import LatestReview from "./latestReview"
import reviewItem from "./reviewItem"
import reviewSection from "./reviewSection"
import PopularArticle from "./popularArticle"
import Page from "./page"
import TourItem from "./tourItem"
import TourList from "./tourList"
import TourListPage from "./tourListPage"
import PrefectureItem from "./prefectureItem"
import SampleAirfareToJapan from "./sampleAirfareToJapan"
import Destination from "./destination"
import AdBannerSection from "./adBannerSection"
import signupForm from "./signupForm"
import AboutSection from "./aboutSection"
import BlogList from "./blogList"
import BlogListPage from "./blogListPage"
import BlogSearch from "./blogSearch"
import { Lang, LangEnum } from "../utils/lang"
import CertMemberSection from "./certMemberSection"
import BusinessServiceSection from "./businessServiceSection"
import CorpHero from "./corpHero"
import NewsSlider from "./newsSlider"
import InquirySection from "./inquirySection"
import CorpSupportSection from "./corpSupportSection"
import CorpNewsSection from "./corpNewsSection"
import relatedTourItem from "./relatedTourItem"
import CorpImgTextRow from "./corpImgTextRow"
import BlogCategory from "./blogCategory"
import LuxuryVaction from "./luxuryVacation"
import LuxuryOverview from "./luxuryOverview"
import LuxuryTours from "./luxuryTours"
import LuxurySeason from "./luxurySeason"
import FlightSection from "./flightSection"
import Hero from "./hero"
import Paragraph from "./paragraph"
import MultiStepForm from "./multiStepForm"
import LuxuryAccommodations from "./luxuryAccommodations"
import AccommodationItem from "./accommodationItem"
import LandingHero from "./landingHero"
import LandingCarousel from "./landingCarousel"
import LandingTourPackages from "./landingTourPackages"
import LandingTourRow from "./landingTourRow"
import LandingTourBanners from "./landingTourBanners"
import LandingImages from "./landingImages"
import Table from "./table"
import LandingAccordion from "./landingAccordion"
import LandingParagraph from "./landingParagraph"
import LandingImageButtons from "./landingImageButtons"
import LandingButton from "./landingButton"
import EmbedForm from "./embedForm"
import RedirectEntry from "./redirectEntry"
import BlogCarousel from "./blogCarousel"
import RelatedArticles from "./relatedArticles"
import FlightExampleSection from "./flightExampleSection"
import LandingPullDown from "./landingPullDown"
import EmbedVideo from "./embedVideo"
import EmbedMap from "./embedMap"
import LandingHeading from "./landingHeading";
import MultiImageCarousel from "./multiImageCarousel";
import GlobalSignupPopUp from "./globalSignupPopup";
import RelatedBlogArticle from "./relatedBlogArticle";
import AdCarousel from "./adCarousel";
import HomeCarousel from "./homeCarousel";


const mySchema = cloneDeep(RichTextSchema); // you can make a copy of the default RichTextSchema

const sbConfig = configuration.plugins.find((item) => item.resolve === 'gatsby-source-storyblok')
// console.log(sbConfig)

storyblokInit({
  accessToken: process.env.STORYBLOK_ACCESS_TOKEN,
  use: [apiPlugin],
  components: {
    author: () => (<></>),
    config: () => (<></>),
    landingConfig: () => (<></>),
    redirect_entry: RedirectEntry,
    page: Page,
    grid: Grid,
    hero: Hero,
    paragraph: Paragraph,
    adCarousel: AdCarousel,
    adBannerSection: AdBannerSection,
    adBannerImage: AdBannerImage,
    menuLink: MenuLink,
    blogArticle: BlogArticle,
    bodyText: BodyText,
    images: Images,
    table: Table,
    location: Location,
    embedVideo: EmbedVideo,
    embedMap: EmbedMap,
    relatedTourItem: relatedTourItem,
    homeCarouselSection: Carousel,
    homeCarouselSection2: HomeCarousel,
    searchTabs: SearchTabs,
    searchTabsJp: SearchTabsJp,
    popularInterestSection: PopularInterest,
    featureSection: FeatureSection,
    destinationSection: Destination,
    reviewSection: reviewSection,
    review: reviewItem,
    popularArticleSection: PopularArticle,
    tourItem: TourItem,
    tourList: TourList,
    tourListPage: TourListPage,
    prefectureItem: PrefectureItem,
    japanAirfareExamplesSection: SampleAirfareToJapan,
    signupForm: signupForm,
    aboutSection: AboutSection,
    certMemberSection: CertMemberSection,
    category: BlogCategory,
    blogList: BlogList,
    blogListPage: BlogListPage,
    blogSearch: BlogSearch,
    blogCarousel: BlogCarousel,
    corpHero: CorpHero,
    businessServiceSection: BusinessServiceSection,
    corpNewsSlider: NewsSlider,
    inquirySection: InquirySection,
    corpSupportSection: CorpSupportSection,
    corpNewsSection: CorpNewsSection,
    corpImgTextRow: CorpImgTextRow,
    luxuryVacation: LuxuryVaction,
    luxuryOverview: LuxuryOverview,
    luxuryTours: LuxuryTours,
    luxuryAccommodations: LuxuryAccommodations,
    luxurySeason: LuxurySeason,
    multiStepForm: MultiStepForm,
    flightSection: FlightSection,
    flightExampleSection: FlightExampleSection,
    accommodationItem: AccommodationItem,
    landingHeading: LandingHeading,
    landingHero: LandingHero,
    landingCarousel: LandingCarousel,
    landingTourPackages: LandingTourPackages,
    landingTourRow: LandingTourRow,
    landingTourBanners: LandingTourBanners,
    landingImages: LandingImages,
    landingAccordion: LandingAccordion,
    landingParagraph: LandingParagraph,
    landingImageButtons: LandingImageButtons,
    landingButton: LandingButton,
    landingPullDown: LandingPullDown,
    embedForm: EmbedForm,
    relatedArticles: RelatedArticles,
    relatedBlogArticle: RelatedBlogArticle,
    multiImageCarousel: MultiImageCarousel,
  },
  richText: {
    schema: mySchema,
    resolver: (component, blok) => {
      switch (component) {
        case "embedVideo":
        case "embedMap":
          return `<div class="flex items-center justify-center overflow-auto">${blok.iframeCode}</div>`;
        default:
          return '';
      }
    },
  },
  apiOptions: {
    region: sbConfig.options.region
  }
});

const Layout = ({ children }) => {

  const { config } = useStaticQuery(graphql`
  query Settings {
    config: allStoryblokEntry(filter: {field_component: {eq: "config"}}) {
      edges {
        node {
          name
          full_slug
          content
        }
      }
    }
  } 
  `)

  const lang = Lang();
  let configSlug = lang === LangEnum.JA ? `ja/config` : 'config'
  let filterConfig = config.edges.filter(edge => edge.node.full_slug === configSlug)
  let langConfig = filterConfig && filterConfig.length ? filterConfig[0].node : {}
  let configContent = typeof langConfig.content === 'string' ? JSON.parse(langConfig.content) : langConfig.content
  let parsedConfig = Object.assign({}, configContent, {content: configContent})
  // console.log(parsedConfig)

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: '<!-- algolia-ignore -->' }} />
      <Navigation config={parsedConfig} />
      <div dangerouslySetInnerHTML={{ __html: '<!-- /algolia-ignore -->' }} />

      <main>{children}</main>
      <Footer config={parsedConfig}/>
      <GlobalSignupPopUp />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
